import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useMediaPredicate } from "react-media-hook";
export const LbToolTip = ({ forId = "default-id", ...props }) => {
  console.log(<ReactTooltip />);
  const smallerThan768 = useMediaPredicate("(max-width: 1056px)");
  return (
    <>
      <ReactTooltip
        anchorId={forId}
        {...props}
        style={
          smallerThan768 && { minWidth: "240px", width: "50%", zIndex: "100" }
        }
      />
    </>
  );
};
